import React, { useContext } from "react";
import { Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { remindersEnabled } from "../../flags";

import Header from "components/Header";
import Sidebar from "components/Sidebar";
import MsgModal from "components/MsgModal";
import UserDetails from "components/UserDetails";
import UserAdmin from "components/UserAdmin";
import UserAccounts from "components/UserAccounts";
import AccountAdmin from "components/AccountAdmin";
import ContractAdmin from "components/ContractAdmin";
import UserBrands from "components/UserBrands";
import BrandAdmin from "components/BrandAdmin";
import OpenQueryLoad from "components/OpenQuery";
import OpenQueryQueries from "components/OpenQueryQueries";
import OpenQueryReminders from "components/OpenQueryReminders";
import OpenQueryQuery from "components/OpenQueryQueries/Query";
import MyFiles from "components/MyFiles";
import MonitoringServicesPage from "components/MonitoringServices";
import QueryVizualizationReportPage from "components/QueryViz";
import Dashboards from "components/Dashboards";
import DashboardVisualizationReportPage from "components/Dashboards/DashboardVisualization";
import HelpArticlesComponent from "components/HelpArticles/HelpArticlesComponent";
import Homepage from "components/Homepage";
import { FooterComponent } from "components/Footer/FooterComponent";

// ✅ Use a RELATIVE import to dodge alias/case issues.
// If your context folder sits at: src/contexts/LoggedInUser
import { LoggedInUserContext } from "../../contexts/LoggedInUser";
import QueryDetails from "components/QueryDetails";

const DashboardView = () => {
  const { loggedInUserProfile } = useContext(LoggedInUserContext) || {};

  // If your LoggedInUserContext already defers rendering until profile is loaded,
  // you might never hit this. Keeping it is harmless and avoids a blank flash.
  if (!loggedInUserProfile?.id) {
    return <div className="p-4 text-muted">Loading your profile…</div>;
  }

  const hasAccounts =
    Array.isArray(loggedInUserProfile.accounts) &&
    loggedInUserProfile.accounts.length > 0;

  return (
    <>
      <div className="container-fluid" style={{ paddingBottom: '3.125rem' }}> {/* margin to accommodate footer height so content is fully visible */}
        <div className="row" style={{ position: 'sticky', top: '0', zIndex: '100', backgroundColor: 'white', outline: 'solid 0.063rem #E5E7EB' }}>
          <div className="col-md-12 px-0">
            <Header />
          </div>
        </div>

        <Switch>
          {/* Routes without Sidebar */}
          <Route exact path="/" component={Homepage} />

          {/* Routes with Sidebar */}
          <Route
            path="/"
            render={() => (
              <div className="row">
              <div className="col-md-12 px-0">
                <div className="container-fluid">
                  <div className="baselayout-wrapper">
                    <Sidebar />

                    <div className="">
                      {/* ⛔️ Don’t hide the entire app when there are no accounts. Show a warning instead. */}
                      {!hasAccounts && (
                        <div className="alert alert-warning mb-3">
                          Your user isn’t assigned to any active accounts yet.
                        </div>
                      )}

                      <Switch>
                        <Route exact path="/User" component={UserDetails} />
                        <Route path="/UserAdmin/:userId" component={UserAdmin} />
                        <Route path="/UserAccounts" component={UserAccounts} />
                        <Route path="/AccountAdmin/:accountId" component={AccountAdmin} />
                        <Route path="/ContractAdmin/:contractId" component={ContractAdmin} />
                        <Route path="/UserBrands" component={UserBrands} />
                        <Route path="/BrandAdmin/:brandId" component={BrandAdmin} />
                        <Route path="/myfiles" component={MyFiles} />
                        <Route path="/aware" component={MonitoringServicesPage} />
                        <Route path="/queryvisualization/:jobId" component={QueryVizualizationReportPage} />
                        <Route path="/dashboards" component={Dashboards} />
                        <Route path="/dashboardVisualization/:dashboardId" component={DashboardVisualizationReportPage} />
                        <Route path="/help" component={HelpArticlesComponent} />

                        {/* OpenQuery routes */}
                        <Route path="/openquery/job/:jobId" component={OpenQueryQuery} />
                        <Route path="/openquery/queries" component={OpenQueryQueries} />
                        {remindersEnabled && (<Route path="/openquery/reminders" component={OpenQueryReminders} />)}
                        <Route path="/openquery/:payerMix/:queryId" component={QueryDetails} />
                        <Route path="/openquery/:payerMix" component={OpenQueryLoad} />
                        <Route path="/openquery" component={OpenQueryLoad} />
                      </Switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            )}
          />
        </Switch>
        <MsgModal />
      </div>
      <FooterComponent />
      <ToastContainer />
    </>
  );
};

export default DashboardView;
